import { render, staticRenderFns } from "./ProDetails.vue?vue&type=template&id=31474d00&scoped=true"
import script from "./ProDetails.vue?vue&type=script&lang=js"
export * from "./ProDetails.vue?vue&type=script&lang=js"
import style0 from "./ProDetails.vue?vue&type=style&index=0&id=31474d00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31474d00",
  null
  
)

export default component.exports